import React, { useState } from "react";
import {
  Box,
  Button,
  Text,
  Avatar,
  Flex,
  Tooltip,
  Spinner,
  Badge,
  Circle,
} from "@chakra-ui/react";
import { timeago } from "../../topUp/utils/timeAgo";
import { HiOutlinePencil } from "react-icons/hi";
import { markAsRead } from "../services/markAsRead";
import { IoCheckmarkDoneSharp } from "react-icons/io5";
import { BsPhone } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

const MESSAGE_REASONS = [
  "message response",
  "message from the admin",
  "message delivered",
  "user reply",
];

export const NotificationStyle = ({
  notification,
  setRefresh,
  currentRecord,
}) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const isMessageNotification = (data) => {
    const reason = (data?.reason || "").toString().toLowerCase().trim();
    return MESSAGE_REASONS.includes(reason);
  };

  const isVtuNotification = (data) => {
    const type = (data?.type || data?.notificationType || data?.category || "")
      .toString()
      .toLowerCase();
    return type === "vtu";
  };

  const getVtuDetails = (data) => ({
    amount:
      data?.amountSent ||
      data?.amount ||
      data?.transactionAmount ||
      "Not available",
    numberOrDecoder:
      data?.number ||
      data?.phoneNumber ||
      data?.decoderNumber ||
      data?.meterNumber ||
      "Not available",
    plan: data?.plan || data?.planName || data?.packageName || "Not available",
  });

  const getResourceLabel = (data) => {
    if (isVtuNotification(data)) return "Airtime";
    return (data?.resource || data?.type || data?.category || "")
      .toString()
      .toUpperCase();
  };

  const handleMarkAsRead = async (id) => {
    setLoading(true);
    await markAsRead(id, setLoading, setRefresh);
  };

  // console.log("not", notification)

  return (
    <>
      <Box
        color="#264653"
        fontSize={"27px"}
        fontWeight="bold"
        py={"20px"}
        pl={["5px", "5px", "0"]}
      >
        Notifications
      </Box>

      {currentRecord?.map(
        (data, i) => (
          //notif?.message?.map((data, i) => (
          <Box
            key={data?._id}
            p={"20px 30px"}
            bg={"#F7F8FA"}
            rounded={"lg"}
            minH={"170px"}
            position={"relative"}
            shadow="lg"
            mb={"20px"}
            overflowY={["scroll", "scroll", "hidden"]}
          >
            <Flex
              justifyContent={"space-between"}
              alignItems={["start", "start", "center"]}
            >
              <Flex>
                {isVtuNotification(data) ? (
                  <Circle size="48px" bg="blue.50" color="blue.500">
                    <BsPhone size={20} />
                  </Circle>
                ) : (
                  <Avatar
                    src={""}
                    name={"Admin"}
                    alt={`Picture of ${"Admin"}`}
                    size={["lg"]}
                  />
                )}
                <Box
                  ml={["15px", "15px", "30px"]}
                  maxW={["100%", "100%", "70%"]}
                >
                  <Text color="#4A4949" fontWeight={400}>
                    {data?.message}
                  </Text>

                  <Box>
                    <Text color={"#2A9D8F"} pt={"5px"} fontSize="15px">
                      {timeago(data?.createdAt)}
                    </Text>
                  </Box>

                  {isMessageNotification(data) && (
                    <Button
                      mt={"10px"}
                      size="sm"
                      colorScheme="teal"
                      variant="outline"
                      onClick={() => navigate("/messages")}
                    >
                      View Message
                    </Button>
                  )}
                </Box>
              </Flex>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="flex-end"
                gap="10px"
              >
                <Badge
                  position={"absolute"}
                  colorScheme={isVtuNotification(data) ? "blue" : "gray"}
                  borderRadius="0 0 0 60px"
                  px="32px"
                  right={"0"}
                  top={"0"}
                  py="8px"
                >
                  {getResourceLabel(data)}
                </Badge>
                {!data?.isRead ? (
                  <Tooltip label="Mark as read">
                    {!loading ? (
                      <HiOutlinePencil
                        cursor={"pointer"}
                        onClick={() => handleMarkAsRead(data?._id)}
                      />
                    ) : (
                      <Spinner />
                    )}
                  </Tooltip>
                ) : (
                  <IoCheckmarkDoneSharp color="green" />
                )}
              </Box>

              {/*<DeleteModal />*/}
            </Flex>

            {/*</CurveBackgroundColor>*/}
          </Box>
        ),
        //))
      )}
    </>
  );
};
